import { NavigationResponse } from '@pylot-data/hooks/cms/use-cms-blocks'
import type { CmsBlock, Maybe } from '@pylot-data/fwrdschema'
import { Blogcategoryposts } from '@pylot-data/api/operations/get-blogcategoriespost'
import { SinglePostData } from '@pylot-data/api/operations/get-singlepost'
import { RecentBlogPost } from '@pylot-data/api/operations/get-blogrecentpost'
import { RelatedPostDetails } from '@pylot-data/api/operations/get-blogreleatedpost'
import { usePreloadedData } from '@preload'
import { BLOG_CMS_BLOCKS } from '@config/preload'

const posturllink = '/blog/'

export const CMSConfigConst = {
    ABOUT_INFO: 'sidebar-banner-1',
    SHOP_NOW: 'blog_shop_now',
    YOU_MAY_LIKE_SLIDER: 'you_may_also_like'
}

export const CMSBlockValueGet = () => {
    const {
        data: {
            cmsBlocks: { items: CmsBlock }
        }
    } = (usePreloadedData(BLOG_CMS_BLOCKS) as unknown) as {
        data: { cmsBlocks: NavigationResponse }
    }
    return CmsBlock
}

export const getCMSBlock = (
    blockIdentifier: string,
    CmsBlock?: Maybe<Array<Maybe<CmsBlock>>>
) => {
    return (
        CmsBlock?.find(
            (block: Maybe<CmsBlock>) => block?.identifier === blockIdentifier
        )?.content || null
    )
}

export interface CmsBlockContent {
    content: string
    identifier: string
    title: string
}

export const formatDate = (date: string) => {
    const dateVal = new Date(date.replace(/-/g, '/'))
    const getMonth = dateVal.toLocaleString('default', { month: 'long' })
    const getDate = dateVal.getDate()
    const getYear = dateVal.getFullYear()
    return `${getMonth} ${getDate}, ${getYear}`
}

export const formatDatetime = (date: string) => {
    const getTime = new Date(date.replace(/-/g, '/')).toLocaleTimeString(
        'en-US',
        {
            hour: '2-digit',
            minute: '2-digit'
        }
    )
    const dateVal = new Date(date.replace(/-/g, '/'))
    const getMonth = dateVal.toLocaleString('default', { month: 'short' })
    const getDate = dateVal.getDate()
    const getYear = dateVal.getFullYear()
    return `${getTime}, ${getDate} ${getMonth} ${getYear}`
}

export const authorTimeCategory = (
    post: SinglePostData | Blogcategoryposts
): string => {
    const author =
        post.author && post.author.name ? `${post?.author?.name}` : ''
    const creationTime = post.creation_time
        ? ` / ${formatDate(post.creation_time)}`
        : ''
    const categoryTitle =
        post.categories && post.categories.length
            ? ` / ${post?.categories[0]?.title}`
            : ''
    return author + creationTime + categoryTitle
}

export const authorName = (
    post: SinglePostData | Blogcategoryposts
): string => {
    return post.author && post.author.name ? `${post?.author?.name}` : ''
}

export const authorTime = (
    post:
        | SinglePostData
        | Blogcategoryposts
        | RecentBlogPost
        | RelatedPostDetails
): string => {
    const time = post.modified_time
    const slashSign = post?.author && time ? '/' : ''
    return time ? ` ${slashSign} ${formatDate(time)}` : ''
}

export const authorTitle = (
    post: SinglePostData | Blogcategoryposts
): string => {
    const title = post?.categories?.map(function (val) {
        return val.title
    })
    return post.categories && post.categories.length
        ? ` / ${title?.join(' , ')}`
        : ''
}

export const authorTitleUrl = (
    post: SinglePostData | Blogcategoryposts
): string => {
    const titleUrl = post?.categories?.map(function (val) {
        return `<a
        href='${posturllink}category/${val.identifier}'
    >
        ${val.title}
    </a>`
    })
    return post.categories && post.categories.length ? `/${titleUrl}` : ''
}

export const generateBlogIdentifier = (url?: Maybe<string>): string => {
    return url ? url.replace(/\s/g, '-') : ''
}

export const facebookUrl = (url?: Maybe<string>): string => {
    return url
        ? `https://www.facebook.com/sharing/share-offsite/?url=${url}`
        : ''
}
export const twitterUrl = (url?: Maybe<string>): string => {
    return url
        ? `https://www.twitter.com/sharing/share-offsite/?url=${url}`
        : ''
}
export const linkedInUrl = (url?: Maybe<string>): string => {
    return url
        ? `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
        : ''
}

export const splitBreadcrumb = (url: string): string => {
    return url.split('-').join(' ')
}
